/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, TextField, Chip, Typography, Divider, Button, CircularProgress, Tabs, Tab, Badge, Tooltip, InputBase, IconButton } from '@material-ui/core'
import Autocomplete from "@material-ui/lab/Autocomplete";

import { AllInclusive } from '@material-ui/icons';
import Actions from '../../../fluid/Actions/ActionFactory'
import ErrorMessage from '../../Common/ErrorMessage'
import Distribution from './components/Distribution'

import { allowedByOpop } from '../../Security/SecureCheck'

const clone = require('rfdc')()

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class ThemeDistribution extends Component {
    state = {
        getting_ic_list : false,
        ic_list_received : false,
        ic_list_error : false,
        theme_ics : [],
        selected_ics : [],
        total_main_themes : null,
        insights_results : null,
        insights_error : null,
        getting_themes : false,
        active_tab : 0,
        drl_url : null,
        level : 0,
        l1_theme : null
    }

    screenHeight = React.createRef()
    searchBarHeight = React.createRef()
    tabBar = React.createRef()
    tabPanel = React.createRef()

    componentWillMount () {
        Actions('http_request', {
            url : "/sainapse/data_rendering_service",
            method : 'get',
            data : {}
        }).then(res => {
            console.log('DRL Result: ', res.data)
            this.setState({...this.state, drl_url : res.data.result[0].url})
        })

        this.getICs();
    }

    getICs = () => {
        this.setState({
            ...this.state,
            getting_ic_list : true
        }, () => {
            if( this.state.ic_list_received === false ){
                Actions('http_request', {
                    url : "/sainapse/information_channel",
                    method : "get",
                    data : {}
                }).then(res => {
                    let theme_ics = []
                    let ic_list = res.data.result
        
                    for (let i = 0 ; i < ic_list.length; i++) {
                        if (ic_list[i].operations.includes("TopicModel")) {
                            let ic = {
                                name : ic_list[i].name,
                                trained : false
                            }
                            if (ic_list[i].training_status_object.findIndex((el) => el.operation === 'TopicModel' && el.status === 'Completed') !== -1) {
                                ic.trained = true
                            }
    
                            theme_ics.push(ic)
                        }
                    }
                    this.setState({
                        ...this.state,
                        theme_ics : theme_ics,
                        getting_ic_list : false,
                        ic_list_received : true,
                        ic_list_error : false
                    }, () => console.log('Theme State: ', this.state))
                }).catch(err => {
                    this.setState({
                        ...this.state,
                        getting_ic_list : false,
                        ic_list_error : true
                    })
                })
            } else {
                this.setState({ getting_ic_list: false })
                return this.state.theme_ics;
            }
            
        })
    }


    getInsights =  (selected_ics) => {
        this.setState({...this.state, getting_themes : true}, () => {
            Actions('http_request', {
                url: "/sainapse/insights?icNames=" + selected_ics,
                method:'get',
                data: {
                    icNames: this.state.selected_ic
                }
            }).then( res => {
                let insights_results_by_icname = res.data.result
               // let insights_results_by_icname = test.data.result
                let modified_insights_results = this.modifyInsightsByLabelsAndWeights(insights_results_by_icname)
                console.log("Modified Themes :", modified_insights_results)
                let collected_insights = modified_insights_results.map(ic_theme => {
                    let main_themes = ic_theme.response.length
                    let other_threshold = ic_theme.max_threshold
                    let themes = ic_theme.response
                    let collection_theme = {
                        topicId : 100,
                        topicIndex : "Other",
                        topicName : "Other",
                        displayLabel : "0",
                        id : 100,
                        overallTopicProportion : "0",
                        topTickets : [],
                        topTopicalTerms : [],
                        children : []
                    }

                    let collected_themes = []
                    console.log("Collected IC Theme: ", collected_themes)
                    console.log("Number of Main Themes: ", main_themes)
                    for (let i = 0; i < main_themes; i++) {
                        console.log("Theme ID: ", themes[i].topicId)
                        console.log("Theme Proportion: ", themes[i].overallTopicProportion)
                        if (themes[i].overallTopicProportion > other_threshold) {
                            collected_themes.push(themes[i])
                        }
                    }
                    let total_main_themes = collected_themes.length
                    collected_themes.push(collection_theme)
        
                    for (let i = 0; i < main_themes; i++) {
                        if (themes[i].overallTopicProportion <= other_threshold) {
                            collected_themes[total_main_themes].children.push(themes[i])
                            collected_themes[total_main_themes].overallTopicProportion = ((parseFloat(collected_themes[total_main_themes].overallTopicProportion) + parseFloat(themes[i].overallTopicProportion)).toFixed(2)).toString()
                            collected_themes[total_main_themes].displayLabel = collected_themes[total_main_themes].overallTopicProportion + "%"
                            collected_themes[total_main_themes].topTickets = [...collected_themes[total_main_themes].topTickets, ...themes[i].topTickets]
                            collected_themes[total_main_themes].topTopicalTerms = [...collected_themes[total_main_themes].topTopicalTerms, ...themes[i].topTopicalTerms]
                        }
                    }


                    // for (let i = main_themes; i < (main_themes + other_themes); i++) {
                    //     collected_themes[main_themes].children.push(themes[i])
                    //     collected_themes[main_themes].overallTopicProportion = ((parseFloat(collected_themes[main_themes].overallTopicProportion) + parseFloat(themes[i].overallTopicProportion)).toFixed(2)).toString()
                    //     collected_themes[main_themes].displayLabel = collected_themes[main_themes].overallTopicProportion + "%"
                    //     collected_themes[main_themes].topTickets = [...collected_themes[main_themes].topTickets, ...themes[i].topTickets]
                    //     collected_themes[main_themes].topTopicalTerms = [...collected_themes[main_themes].topTopicalTerms, ...themes[i].topTopicalTerms]
                    // }

                    collected_themes[total_main_themes].topTopicalTerms.sort((a, b )=> b.weight - a.weight)
                    collected_themes[total_main_themes].children.map(child_theme => {
                        child_theme.overallTopicProportion = (parseFloat(child_theme.overallTopicProportion)/parseFloat(collected_themes[total_main_themes].overallTopicProportion) * 100).toFixed(2).toString()
                    })
                    let new_ic_theme = clone(ic_theme)
                    new_ic_theme.response = collected_themes
                    new_ic_theme.main_themes = total_main_themes
                    return new_ic_theme
                })

                console.log("Collected Themes :", collected_insights)
                this.setState({
                    ...this.state,
                    getting_themes : false,
                    insights_results:  collected_insights,
                    insights_error : null,
                    active_tab : 0
                }, () => {
                    //this.getThemeResults()
                    console.log("Theme State: ", this.state)
                })
            }).catch(err => {
                this.setState({
                    ...this.state,
                    getting_themes : false,
                    insights_results : null,
                    insights_error : err
                }, () => console.log("Theme State: ", this.state))
            })
        })
    }

    modifyInsightsByLabelsAndWeights =  (insights_results_by_icname) => {
        return  insights_results_by_icname.map((element) => {
            let ic_name = element.ic_name;
            let topics = element.response
            let main_themes = element.number_of_clusters
            let max_threshold = element.match_threshold
            topics.map((singleTopic, i) => {
                singleTopic.id = i
                
                if(singleTopic.topicName === 'Unnamed'){
                    singleTopic.topicIndex = 'Theme ' + singleTopic.topicId
                } else {
                    singleTopic.topicIndex = singleTopic.topicName
                }
                singleTopic.overallTopicProportion = ((singleTopic.overallTopicProportion * 100).toFixed(2)).toString()
                singleTopic.displayLabel = singleTopic.overallTopicProportion + '%'
                
                let topicalTerms = singleTopic.topTopicalTerms
                let totalTermWeight = 0
                //let topTickets = singleTopic.topTickets
                topicalTerms.map((term) => {
                    totalTermWeight = totalTermWeight + term.weight
                })
                
                topicalTerms.map((term) => {
                    term.displayWeight = ((term.weight / totalTermWeight) * 100).toFixed(2).toString()
                })

                return singleTopic
            })

            let insights = {
                ic_name: ic_name,
                response: topics,
                main_themes : main_themes,
                max_threshold : max_threshold
            }

            return insights;

        })
    }

    handleICSelectChange = (event, newValue ) => {
        let new_ics_arr = newValue;
        let new_ics = [];
        new_ics_arr.forEach((element, index) => {   
            if(new_ics.indexOf(element.name) == -1){
                new_ics.push(element)
            }
        })
        
        this.setState({ selected_ics: new_ics, getting_ic_list: false  });
    }

    getHelperText= () => {
        var accessObject = {
            operation : "/sainapse/insights/topics/name",
            method : "POST",
            operands : []
        }
        return !allowedByOpop(accessObject) ? 'User does not have sufficient privileges' : ''
    }

    renderSearchBar = () => {
        return (
            <div ref = {this.searchBarHeight} style = {{width : '100%', padding : '5px'}}>
                <Paper square elevation = {4} style = {{width : '100%', padding : '5px'}}> 
                    <div>
                        <Typography variant = 'h6' style = {{fontWeight : 600}}>Theme Discovery</Typography>
                    </div>
                    <Divider style = {{marginBottom : '10px'}}/>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                        <Autocomplete
                            style = {{marginRight : '5px', flexGrow : 1}}
                            multiple
                            id="tags-standard"
                            loading = {this.state.getting_ic_list}
                            options={this.state.theme_ics}
                            onOpen = {this.getICs}
                            getOptionLabel={(option) => option.name}
                            getOptionDisabled = {(option) => option.trained === false}
                            //onChange = {(event, newValue) => this.setState({...this.state, selected_ics : newValue}, () => console.log('Theme State: ', this.state))}
                            onChange = {(event, newValue) => this.handleICSelectChange(event, newValue)}
                            disabled = {!allowedByOpop({
                                operation : "/sainapse/insights/topics/name",
                                method : "POST",
                                operands : []
                                })}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    size = 'small'
                                    label="Select Information Channels"
                                    helperText= {this.getHelperText()}
                                />
                                )}
                            ChipProps = {{
                                color : 'primary',
                                size : 'small'
                            }}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : '1px solif rgba(0,0,0,0.12)'}}>
                                        <Typography style = {{flexGrow : 1}}>{option.name}</Typography>
                                        {option.trained === false ? <Typography variant = 'caption'>Not Trained</Typography> : null}
                                    </div>
                                </React.Fragment>
                            )}
                        />
                        <Button
                            variant = 'contained'
                            color = 'primary'
                            size = 'small'
                            disabled = {this.state.selected_ics.length === 0}
                            onClick = {() => {
                                let selected_ics = this.state.selected_ics.map(ic => {
                                    return ic.name
                                })
                                this.getInsights(selected_ics)
                            }}
                            startIcon = {this.state.getting_themes ? <CircularProgress style = {{color : "#FFFFFF"}} size = {15}/> : <AllInclusive size = 'small'/>}
                        >{this.state.getting_themes ? "Discovering" : "Discover"}</Button>
                    </div>
                    {this.state.insights_error !== null ? <ErrorMessage style = {{marginTop : '5px'}} error_message = "Error Retreiving Themes" err = {this.state.insights_error}/>
                    : null}
                </Paper>
            </div>
        )
    }

    renderThemes = () => {
        if (this.state.insights_results) {
            let container_height = this.screenHeight.current.clientHeight - this.searchBarHeight.current.clientHeight
            return (
                <div style = {{width : '100%', height : container_height, display: 'flex', flexDirection : 'column'}}>
                    {this.renderTabs()}
                    {this.renderTabPanel()}
                </div>
            )
        }
    }

    handleTabChange = (event, newValue) => {
        this.setState({
            ...this.state,
            active_tab : newValue
        })
    }

    renderTabs = () => {
        return (
            <div ref = {this.tabBar} style = {{width : '100%'}}>
                <Paper  elevation = {2} style = {{width: "100%"}} square>
                    <Tabs
                        value={this.state.active_tab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable result tabs"
                    >
                        {
                            this.state.insights_results.map((ic, i) => {
                                return (
                                    <Tab
                                        style = {{
                                            paddingLeft: '20px',
                                            paddingRight : '20px'
                                        }}
                                        disableRipple = {true}
                                        wrapped = {false}
                                        label = {
                                            <Badge
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                //className = {classes.badge}
                                                overlap = 'rectangle'
                                                //badgeContent={this.getResultCount(ic)} 
                                                color= {this.state.active_tab === i ? "primary" : "default"}  
                                                showZero
                                            >
                                                <Tooltip title = {ic.ic_name}>
                                                    <Typography noWrap = {true} variant = 'caption'>{ic.ic_name}</Typography>
                                                </Tooltip>
                                            </Badge>
                                        }/>
                                )
                            })
                        }
                    </Tabs>
                </Paper>
            </div>
        )
    }

    renderTabPanel = () => {
        return (
            <div ref = {this.tabPanel} style = {{width : '100%', flexGrow : 1, overflow : 'auto'}}>
                {this.renderDistributionLevels(this.state.level)}
                {/* <Distribution
                    drl_url = {this.state.drl_url}
                    key = {this.state.insights_results[this.state.active_tab].ic_name}
                    themes = {this.state.insights_results[this.state.active_tab]}
                    get_insights = {() => {
                        let selected_ics = this.state.selected_ics.map(ic => {
                            return ic.name
                        })
                        this.getInsights(selected_ics)
                    }}
                /> */}
            </div>
        )
    }

    renderDistributionLevels = (level) => {
        if (level === 0) {
            return(
                <Distribution
                    drl_url = {this.state.drl_url}
                    key = {this.state.insights_results[this.state.active_tab].ic_name}
                    themes = {this.state.insights_results[this.state.active_tab]}
                    get_insights = {() => {
                        let selected_ics = this.state.selected_ics.map(ic => {
                            return ic.name
                        })
                        this.getInsights(selected_ics)
                    }}
                    level = {this.state.level}
                    switch_level = {(level, theme) => this.switchLevel(level, theme)}
                />
            )
        } else {
            let themes = {
                ic_name : this.state.insights_results[this.state.active_tab].ic_name,
                response : this.state.insights_results[this.state.active_tab].response[this.state.insights_results[this.state.active_tab].main_themes].children
            }
            return(
                <Distribution
                    drl_url = {this.state.drl_url}
                    key = {"level1"}
                    themes = {themes}
                    get_insights = {() => {
                        let selected_ics = this.state.selected_ics.map(ic => {
                            return ic.name
                        })
                        this.getInsights(selected_ics)
                    }}
                    level = {this.state.level}
                    switch_level = {(level, theme) => this.switchLevel(level, theme)}
                />
            )
        }
    }

    switchLevel = (level) => {
        this.setState({
            ...this.state,
            level : level
        })
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <div 
                ref = {this.screenHeight}
                style = {{
                    boxSizing : 'border-box',
                    width : '100%',
                    height : 'calc(100vh - 48px)',
                    display: 'flex',
                    flexDirection : 'column'
                }}>
                    {this.renderSearchBar()}
                    {this.renderThemes()}
                </div>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(ThemeDistribution);